export default {
  title: "RC CITY жөнүндө Толук Маалымат",

  balance: {
    info: {
      title: "Баланстын маалыматы",
      paragraphs: [
        "Балансыңызда өз ара эсептешүү мезгилинде сизге төлөнө турган каражаттар жөнүндө маалымат көрсөтүлөт.",
        "Ошондой эле «Баланс» барагында каражаттарыңыздын учурдагы абалын түшүнүүгө жана каржыңызды жакшыраак көзөмөлдөөгө жардам берген толук детализация берилет.",
      ],
    },
    settings: {
      title: "Каражаттарды чыгаруу жөндөөлөрү",
      paragraphs: [
        "Каражаттарды чыгаруу үчүн жөндөөлөрдөн төлөө ыкмасын тандоо керек. Төлөм келишимдин 4.6-пунктуна ылайык жүргүзүлөт. Эгерде RC CITY кабинетинде эч кандай вариант тандабасаңыз, көрсөтүлгөн мезгилде бул юридикалык жак үчүн төлөм жүргүзүлбөйт.",
        "Чыгарылуучу сумманы коюу үчүн төмөнкүлөрдү жасаңыз:",
      ],
      list: [
        {
          text: "Оң жактагы жогорку бурчтагы «Баланс» баскычын басып, «Баланс» бөлүмүнө өтүңүз.",
        },
        {
          text: "Баланс картасында «Жөндөөлөр» баскычын басыңыз.",
        },
        {
          text: "Каражаттарды чыгаруунун ыкмасын тандаңыз:",
          list: [
            "«Чыгарууга резервделген сумма» боюнча — Каражаттар төлөнүү учуруна чейин резервге алынат жана тариф же кызмат сатып алууга колдонулбайт, анткени реалдуу баланс көрсөтүлгөн суммага азаят. Эгерде «Чыгарууга жеткиликтүү сумма» 300 RCден аз болсо, бул ыкма жеткиликсиз болот. Сумманы өзүңүз белгилейсиз.",
            "«Чыгарууга жеткиликтүү сумма» боюнча — Төлөм өз ара эсептешүү учурундагы баланстын «Чыгарууга жеткиликтүү» суммасына барабар өлчөмдө жүргүзүлөт, эгерде ал 300 RCден кем болбосо.",
          ],
        },
        {
          text: "«Колдонуу жана жабуу» баскычын басыңыз.",
        },
      ],
    },
  },

  analytic: {
    title: "Аналитика",
    entities: {
      title: "Юридикалык жактар",
      paragraphs: [
        "<b>«Аналитика»</b> бөлүмүндө RC PAY колдонгон бардык жайлар жана кардарлар боюнча аналитикалык маалымат берилет. Маалыматтар беш бөлүмгө бөлүнгөн жана ар бири өзүнчө маалыматка басым жасайт.",
        "<b>«Юридикалык жактар»</b> бөлүмүндө кардарлар боюнча жалпы маалыматтарды, анын ичинде жаңы кардарларды көрүүгө, орточо чекти, сатып алуулар санын жана жалпы сатуу суммасын билүүгө болот. Ошондой эле ар бир катталган уюм боюнча деталдуу маалымат алып, сизди кызыктырган мезгилди тандасаңыз болот — күн, жума, ай же жыл үчүн сатуу статистикасын көрө аласыз.",
      ],
    },
    points: {
      title: "Соода чекиттери",
      p1: "<b>«Соода чекиттери»</b> бөлүмүндө мурунку бөлүмдүн кеңейтилген аналитикасы көрсөтүлөт:",
      list: [
        "кардарлар боюнча маалыматтар;",
        "сатуулар;",
        "тандалган мезгилдеги сатуулардын жалпы суммасы;",
        "ар бир уюм боюнча маалымат;",
        "кызматкерлердин активдүүлүгү жөнүндө маалымат;",
        "ар бир кызматкер боюнча сатуулардын суммасы;",
        "кассирлердин упайлары.",
      ],
      p2: "<b>«Бардык соода чекиттери»</b> дегенди тандап, бардык чекиттер боюнча жалпы маалыматты көрүүгө болот.",
    },
    employees: {
      title: "Кызматкерлер",
      p1: "<b>«Кызматкерлер»</b> бөлүмүндө сиз кызматкерлердин активдүүлүгүн байкап, белгилүү бир мезгилдеги алардын өндүрүмдүүлүгүн төмөнкү көрсөткүчтөр боюнча баалай аласыз:",
      list: [
        "транзакция жүргүзгөн кызматкердин аты;",
        "соода чекити;",
        "сатуулар саны;",
        "сатуулар суммасы;",
        "кассир упайлары;",
        "жок кылынган баллдардын саны;",
        "эсептелген баллдардын саны.",
      ],
      p2: "<b>«Бардык соода чекиттери»</b> дегенди тандап, бардык чекиттер боюнча маалыматты көрүүгө болот.",
    },
    rfm: {
      title: "RFM-анализ",
      paragraphs: [
        "<b>«RFM-анализ»</b> бөлүмүндө кардарлар сатып алууларды канчалык тез-тез жана кандай суммада жүргүзгөнүнө жараша сегменттелген анализ көрсөтүлөт. Бул сизден эң көп сатып алуучу кардарларды аныктоого жардам берет.",
        "Маалыматты алуу үчүн түшүп чыккан тизмеден <b>«Юридикалык жакты»</b> жана <b>«Календардан»</b> мезгилди тандаңыз. Натыйжада <b>«Баллдарды эсептөө»</b> бөлүмүндө түзүлгөн топтор боюнча анализ таблицасы көрсөтүлөт.",
      ],
    },
    portrait: {
      title: "Кардардын портрети",
      paragraph:
        "<b>«Кардардын портрети»</b> бөлүмүндө тандалган уюмдун бардык кардарлары тууралуу деталдуу маалыматты көрүп, туруктуу кардарларды аныктай аласыз. Жаш курак диаграммасында төмөнкү маалыматтар көрсөтүлөт:",
      list: [
        "ушул жаш категориясындагы кардарлардын саны;",
        "алардын орточо чеги;",
        "сатып алуулар саны;",
        "сатуулар суммасы.",
      ],
    },
  },

  loyalty: {
    title: "Лоялдуулук программасы",

    accrualPoints: {
      title: "Баллдарды эсептөө",
      p1: "<b>«Баллдарды эсептөө»</b> бөлүмүндө сиз кардарларга берилүүчү баллдардын пайыздык өлчөмүн орното аласыз. Минималдуу пайыз – 4%, ал эми максималдуу – 25%. Кардарлардын ишенимин арттыруу үчүн аларды сатып алуулар суммасына жараша топторго бөлүп, ар бир топко өзүнчө сыйлык пайызы белгилеңиз.",
      p2: "Кардарлар тобун түзүү үчүн төмөнкү кадамдарды аткарыңыз:",
      list: [
        {
          text: "Кардарлар тобун түзгүңүз келген соода чекиттерин тандаңыз. Мисалы:",
          list: [
            "Жаңы кардар – сатып алуулар суммасы 10 000 сомго чейин болсо, сыйлык 5%.",
            "Туруктуу кардар – сатып алуулар 10 000 сомдон жогору болсо, сыйлык 10%.",
            "Жакшы кардар – сатып алуулар 50 000 сомдон жогору болсо, сыйлык 20%.",
          ],
        },
        { text: "«Топ түзүү» баскычын басыңыз." },
      ],
      p3: "Бул баракта сиз <b>«Соода чекитинин учурдагы кечигүүсүн»</b> да орното аласыз – бул кардарга сатып алуу үчүн сыйлык баллдары эсептелгенге чейинки күндөрдүн саны. Маани 0дөн 14 күнгө чейин болушу мүмкүн. <b>«Кечигүүнү өзгөртүү»</b> баскычын басып, керектүү мөөнөттү көрсөтүп, андан соң <b>«Сактоо»</b> дегенди басыңыз. Эске алыңыз: бул функция RC CITY балансында каражат болгондо гана туура иштейт.",
    },

    promo: {
      title: "Акциялар",
      p1: "<b>«Акциялар»</b> бөлүмүндө сиз өзүңүздүн жайлар үчүн акцияларды түзүп жана аларды бир эле учурда же өзүнчө көзөмөлдөй аласыз. Маалымат таблица түрүндө көрсөтүлөт: акциянын аталышы, өткөрүлүүчү соода чекити, баллдарды эсептөө пайызы (мурунку бөлүмдөгү пайыз менен кошулбайт), жана арзандатуу пайызы. Ар бир акциянын жанында <b>RC KASSA</b> аркылуу жашыруу, өзгөртүү жана жок кылуу мүмкүнчүлүгү бар.",
      p2: "Акция түзүү үчүн ачылган терезеде төмөнкүлөрдү көрсөтүңүз:",
      list: [
        "соода чекити;",
        "акциянын аталышы;",
        "баллдарды эсептөө пайызы;",
        "арзандатуу пайызы.",
      ],
      p3: "Акция ийгиликтүү түзүлгөндөн кийин, кызматкер катары <b>RC KASSA</b> тиркемесине кирип, <b>«Акциялар»</b> баскычын басканыңызда, түзүлгөн акция көрүнөт.",
    },

    operations: {
      title: "Операциялар тарыхы",
      paragraphs: [
        "<b>«Бардык операциялар»</b> бөлүмүндө <b>«Операциялар тарыхы»</b> барагында RC CITY балансындагы бардык толуктоолор жана каражат чыгымдоолор таблица түрүндө көрсөтүлөт. Толугураак маалымат алуу үчүн календарды колдонуп керектүү мезгилди тандасаңыз болот.",
        "Ошондой эле бул барактан белгилүү бир мезгил же бардык убакыт боюнча операциялар тарыхын жүктөп алууга болот. Бул үчүн <b>«Жүктөп алуу»</b> баскычын басыңыз, жүктөө форматтын тандаңыз жана кааласаңыз <b>«Көчүрмөнү электрондук почтага жөнөтүү»</b> белгисин коюңуз. Бул учурда файл RC CITY каттоосунда көрсөтүлгөн почта дарегиңизге жөнөтүлөт. Андан кийин дагы бир жолу «Жүктөп алуу» баскычын басыңыз.",
        "<b>RC Processing</b> бөлүмүндө касса аппараты аркылуу жүргүзүлгөн бардык операциялар боюнча маалымат көрсөтүлөт.",
      ],
    },
  },

  clients: {
    title: "Кардарлар",
    clients: {
      title: "Кардарлар тизмеси",
      paragraphs: [
        "«Кардарлар тизмеси» бөлүмүндө сиз өз кардарларыңыз тууралуу маалыматты көрө аласыз. Маалыматты көрүү үчүн тизмеден уюмду тандаңыз же «Бардык уюмдар» пунктуна белгини коюңуз.",
        "<b>«Бардык кардарлар»</b> өтмөгүндө сиз жайыңыздын бардык кардарлары тууралуу маалыматты көрөсүз. <b>«Ички кардарлар»</b> өтмөгү сиздин жайыңызда катталган кардарлар боюнча маалыматты көрсөтөт. Ал эми <b>«Тышкы кардарлар»</b> өтмөгүндө сиздин жайыңызга келип, жок дегенде бир жолу сатып алуу жасаган кардарлар тууралуу маалымат көрсөтүлөт.",
        "Барактын төмөн жагында <b>«Чакыруу»</b> баскычы жайгашкан, аны басуу менен сиз кардарды каттоо үчүн шилтемени көчүрүп же QR-кодду жүктөп ала аласыз.",
      ],
    },
    reviews: {
      title: "Пикирлер",
      p1: "«Пикирлер» бөлүмүндө сиздин жайыңызга келип, rcpay.ru сайтында же RC PAY тиркемесинде пикир калтырган бардык кардарлардын пикирлери көрсөтүлөт.",
      p2: "Пикирлер менен иштөөнү жеңилдетүү үчүн бир нече чыпка (фильтр) каралган:",
      list: [
        {
          text: "<b>«Соода чекитин тандаңыз»</b> баскычын басканда кардар белгилүү бир чекит боюнча калтырган пикирлер көрсөтүлөт. Ал эми <b>«Бардык соода чекиттери»</b> пунктун тандасаңыз, бардык чекиттер боюнча пикирлерди көрө аласыз.",
        },
        {
          text: "Белгилүү бир мезгил же күн үчүн пикирлерди көрүү мүмкүнчүлүгү бар. Бул үчүн календарды ачып, керектүү мезгилди тандаңыз же аны кол менен белгилеңиз.",
        },
        {
          text: "Пикирлерди 3 өзгөчөлүк боюнча чыпкалоого болот:",
          list: [
            "жаңылыгы боюнча;",
            "жакшы пикирлер гана;",
            "терс пикирлер гана.",
          ],
        },
      ],
      p3: "Сиз ошондой эле rcpay.ru сайтында жана RC PAY тиркемесинде көрсөтүлө турган пикирлерди өз алдынча тандай аласыз. Бул үчүн көрсөтүлүшүн каалаган пикирлердин жанындагы көрүү белгисин басыңыз. Эске алыңыз: жашырылган пикирлер сайттагы жайдын рейтингине таасир этпейт.",
    },
    push: {
      title: "Wallet Push-билдирмелери",
      p1: "<b>«Wallet Push-билдирмелери»</b> бөлүмүндө сиз кардарлар үчүн билдирүү жөнөтүүлөрүн орното аласыз, ошентип алар сиздин акциялар жана иш-чаралар тууралуу кабардар болуп турушат.",
      list: [
        "Б bunun үчүн «Push-рассылканы түзүү» пунктунун жанына жайгашкан плюс белгисин басыңыз жана тиешелүү талааларды толтуруңуз;",
        "Билдирмени жөнөтө турган соода чекитин тандаңыз;",
        "Теманын текстин киргизиңиз (мисалы: «Бардыгына майрамдык арзандатуу!»);",
        "Push-билдирме тексти 15 мүнөт ичинде жөнөтүлөт. Эске алыңыз: билдирүү түзүлгөндөн кийин аны өзгөртүү мүмкүн эмес. Бардык жөнөтүлгөн билдирмелер ушул эле баракта таблица түрүндө көрсөтүлөт. Ар бир билдирме боюнча «Кененирээк» баскычы аркылуу соода чекитин, жөнөтүү датасын жана текстти көрүүгө болот.",
      ],
      p2: "Сиздин кардарлар push-билдирмени 15 мүнөт ичинде алышат. Эске алыңыз: билдирүү түзүлгөндөн кийин аны өзгөртүү мүмкүн эмес. Бардык жөнөтүлгөн билдирмелер ушул эле баракта таблица түрүндө көрсөтүлөт. Ар бир билдирме боюнча «Кененирээк» баскычы аркылуу соода чекитин, жөнөтүү датасын жана текстти көрүүгө болот.",
    },
  },

  cards: {
    title: "Лоялдуулук карталары",
    spread: {
      title: "RC карталарын жайылтуу",
      p: "Wallet картасы — бул дүкөндөрдүн жана мекемелердин карталарынын электрондук эквиваленти. <b>«RC карталарын жайылтуу»</b> бөлүмүндө кардарларды санарипке өткөрүү үчүн QR-кодду, ошондой эле картаны жүктөп алуу шилтемесин алууга болот. Бул шилтемени социалдык тармактарда, веб-сайтта жана башка булактарда жайгаштырып, дүйнөнүн каалаган жеринен кардарларды санарипке өткөрүүгө мүмкүнчүлүк берет.",
    },
    design: {
      title: "Wallet картасынын дизайны",
      p1: "<b>«Wallet картасынын дизайны»</b> бөлүмүндө карталарыңызга уникалдуу дизайн түзүү мүмкүнчүлүгү берилет. Бул үчүн:",
      list: [
        "«Уюмду тандоо» бөлүмүндөгү тизмеден Wallet картасын түзгүңүз келген уюмду тандаңыз.",
        "Фонду тандаңыз: «Wallet картаңыздын фону үчүн сүрөттү киргизиңиз» терезесине файлды сүйрөп киргизиңиз же жүктөңүз. Файлдын көлөмү 2 МБдан ашпашы керек, сүрөттүн катышы 16:9 болушу зарыл.",
        "Логотипти тандаңыз: «Wallet картаңыздын логотибин киргизиңиз» терезесине файлды сүйрөп киргизиңиз же жүктөңүз. Файлдын көлөмү 2 МБдан ашпашы керек, катышы 1:1 болушу керек.",
        "QR-коддун, аталыштын жана карта номеринин түсүн тандаңыз.",
      ],
      p2: "Орнотууларды сактоо үчүн «Дизайнды өзгөртүү» баскычын басыңыз, ал эми параметрлерди баштапкы абалга кайтаруу үчүн — <b>«Стандарттык дизайнга кайтаруу»</b> баскычын колдонуңуз.",
    },
  },

  employee: {
    title: "Менин кызматкерлерим",
    manager: {
      title: "Менеджерлер",
      p1: "<b>«Менеджерлер»</b> бөлүмүндө ТСП ээси тарабынан катталган бардык менеджерлер көрсөтүлөт:",
      list: ["Кызматкердин аты-жөнү;", "Кызматы;", "Телефон номери;"],
      p2: "Ошондой эле менеджерди кошуу, өзгөртүү, бөгөт коюу же өчүрүү мүмкүн. Менеджер кошуу үчүн «плюс» баскычын басып, фамилиясын, атын, атасынын атын, кызмат ордун, телефон номерин киргизип, жеке кабинеттерге кирүү укуктарын орнотуңуз. Кирүү үчүн логин жана сырсөз система тарабынан автоматтык түрдө түзүлөт. Эскерте кетели: сырсөз менеджерди кошкондон кийин бир жолу гана көрсөтүлөт. Аны өзүнө ыңгайлуу жерде сактап коюу сунушталат, анткени кийин программада көрсөтүлбөйт.",
      p3: "Маанилүү: менеджер RC KASSA тиркемесинде транзакция жүргүзүү мүмкүнчүлүгүнө ээ эмес.",
    },
    cashier: {
      title: "Кассирлер",
      paragraphs: [
        "«Кассирлер» бөлүмүндө бардык түзүлгөн кызматкерлердин маалыматы көрсөтүлөт. Кызматкерди түзүү үчүн «плюс» баскычын басып, фамилиясын, атын киргизип жана анын иштеген соода чекитин тандаңыз. Таблицада RC KASSA'га кирүү үчүн зарыл болгон логин, сырсөз жана кызматкердин статусу көрсөтүлөт.",
        "Мындан тышкары, бул бөлүмдө топтолгон упайлар боюнча маалыматты көрүүгө, кызматкерди бөгөт коюуга же өчүрүүгө болот.",
      ],
    },
  },

  fabrics: {
    title: "Менин ишканаларым",
    entities: {
      title: "Юридикалык жактар",
      p1: "<b>«Юридикалык жактар»</b> бөлүмүндө Сиз өзүңүздүн уюмуңузду кошуп, анын мекемелерине лоялдуулук программасын колдонсоңуз болот. Бул үчүн «Юридикалык жактар» жазуусунун жанындагы плюс белгисин басып, бардык талааларды толтуруңуз:",
      list1: [
        "Уюмдун СТН (ИНН);",
        "юридикалык аталышы;",
        "юридикалык дареги;",
        "уюмду тейлеген банк;",
        "БИК;",
        "корреспонденттик эсеп;",
        "эсептик эсеп;",
        "жетекчинин аты-жөнү.",
      ],
      p2: "Корреспонденттик жана эсептик эсептерге өзгөчө көңүл буруңуз. Алардын узундугу бирдей болушу жана кошумча белгилер (боштук, чекит ж.б.) болбошу керек. Эгер уюмдун түрү катары «Халяль» тандалса, анда аны тастыктаган документти pdf, jpeg же png форматында жүктөө зарыл.",
      p3: "Экинчи жана андан кийинки уюмдарды кошуу мүмкүнчүлүгү төлөмдүү тарифтерде гана жеткиликтүү. Эгер сизде бир нече уюм болсо, алардын кайсынысы негизги болорун тандай аласыз — ал тариф төмөндөгөн учурда да активдүү бойдон калат. Уюм түзүлгөндөн кийин модерация абалын көзөмөлдөй аласыз:",
      list2: [
        "«Тастыкталды» — бардык маалымат туура толтурулуп, текшерүү ийгиликтүү аяктады;",
        "«Четке кагылды» — маалымат туура эмес же тактоону талап кылат. Модератордун комментарийлерине көңүл буруңуз — алар кайсы маалыматты оңдоо керектигин көрсөтөт;",
        "«Модерацияда» — уюм текшерүүнү күтүп турат же учурда текшерилип жатат.",
      ],
      p4: "Эгер модерация четке кагылса, «Модерациянын жообу» талаасында себеби көрсөтүлгөн билдирүү чыгат. Аны кунт коюп окуп чыгып, модератордун сунуштарын аткарыңыз.",
      p5: "Ошондой эле тандалган уюм боюнча маалыматты «Кененирээк» баскычы аркылуу көрө аласыз:",
      list3: [
        "уюмдун аталышы;",
        "ИНН;",
        "юридикалык дареги;",
        "банктын БИКи;",
        "эсептик эсеп;",
        "корреспонденттик эсеп;",
        "депозит суммасы.",
      ],
    },
    points: {
      title: "Соода чекиттери",
      paragraphs: [
        "<b>«Соода чекиттери»</b> бөлүмүндө бардык катталган чекиттердин тизмеси жана чек тарыхы көрсөтүлөт. Ошондой эле бул жерден керектүү учурда чекитти өчүрүү мүмкүн.",
        "Жаңы соода чекитин кошуу үчүн «Түзүү» баскычын басыңыз. Андан кийин бардык милдеттүү талааларды толтуруңуз. Ыңгайлуулук үчүн талаалардын жанында кеңештер көрсөтүлгөн. Сиздин мекемени мүмкүн болушунча так сүрөттөп, сүрөттөр жана түшүндүрмөлөр аркылуу анын өзгөчөлүгүн белгилеңиз.",
        "Өз ара эсептешүүлөр жүргүзүлө турган юридикалык жакты көрсөтүү маанилүү. Бул үчүн тизмеден тиешелүү юридикалык жакты тандаңыз. Маалымат модерацияга жөнөтүлөт. Текшерүү абалын төмөнкүдөй статустар аркылуу байкай аласыз:",
      ],
      list: [
        "«Тастыкталды» — бардык маалымат туура толтурулуп, текшерүү ийгиликтүү өттү. Бул учурда Сиздин чекит rcpay.ru сайтында жана RC PAY тиркемесинде көрсөтүлөт.",
        "«Четке кагылды» — маалымат жетишсиз же тактоо талап кылынат. Модератор түшүндүрмө билдирүүсүн жөнөтөт.",
        "«Модерацияда» — чекит текшерүүнү күтүп турат же учурда текшерилип жатат.",
      ],
      p: "Чектердин тарыхын көрүү үчүн тиешелүү чекиттин карточкасындагы чек белгисин басыңыз. Таблицаны сорттоп, фильтрлеп же белгилүү бир транзакцияны кененирээк көрө аласыз.",
    },
    documents: {
      title: "Документтер",
      p: "«Документтер» бөлүмүндө «Документтер» жана «Маркетингдик материалдар» өтмөлөрүндө RC GROUP компаниясынын продукциясына тиешелүү нускамалар жана материалдар менен тааныша аласыз.",
    },
    tariffs: {
      title: "Тарифтер",
      p: "<b>«Тарифтер»</b> бөлүмүндө бардык жеткиликтүү тарифтер көрсөтүлөт. Тариф сатып алуу үчүн керектүүсүн тандап, «Тарифти сатып алуу» баскычын басыңыз, андан соң «Юридикалык жакты» тандап, «Төлөө» баскычын басыңыз. Төлөмдү жүргүзүү үчүн балансты толуктап, «Баланстагы» бөлүмдө эсеп түзүп, аны тандалган уюмдун реквизиттеринен төлөңүз.",
    },
  },

  paymentDecision: {
    title: "Төлөм чечими",
    paymentMethod: {
      title: "Төлөө ыкмалары",
      p1: "Төлөм чечимин кошуудан мурун нускаманы окуп чыгып, иштөө үчүн керектүү шарттар менен таанышыңыз. Ошондой эле, сиздин мекеме төлөм чечимин кошууга тыюу салынган категорияларга кирбей турганын текшериңиз.<br /><br /> <b>«Төлөө ыкмалары»</b> бөлүмүндө төлөм чечимин кошкуңуз келген соода чекитин тизмеден тандаңыз.<br /> Соода чекитин тандагандан кийин, кошуу үчүн арыз түзө аласыз.<br /><br /> Арыз жөнөтүүдөн мурда маалыматтарды текшериңиз:",
      list: [
        "Байланыш маалыматтары: дарек жана телефон номери. <br /> Телефон номери кассалык чектерде көрсөтүлүшү жана байланыш үчүн зарыл.",
        "Юридикалык жак: бардык маалыматтын туура экенин текшериңиз.",
        "Банктык реквизиттер: киргизилген маалыматтын тактыгына көңүл буруңуз.",
      ],
      p2: "Эгер реквизиттерде ката кетсе, оңдоо үчүн колдоо кызматына кайрылыңыз — муну оң жак ылдыйкы бурчтагы байланыш формасы аркылуу жасоого болот.<br /><br /> Бардык маалыматтарды толтургандан кийин төмөнкү пункттардын жанындагы кутучаларды белгилеңиз: «Жеке маалыматтарды <b>Купуялык саясатына</b> ылайык иштетүүгө макулмун» жана «Лицензиялык келишимдин жана Жеке маалыматтарды иштетүү саясатынын шарттарын кабыл алам». Андан кийин «Арыз жөнөтүү» баскычын басыңыз.<br /><br /> Арыз жөнөтүлгөндөн кийин RC GROUP менеджери сиз менен байланышып, кошуунун кийинки кадамдары тууралуу маалымат берет.<br /><br /> Ошондой эле <b>«Төлөө ыкмалары»</b> бөлүмүндө «Арыздар тарыхы» өтмөгүнөн төлөм чечимин кошуунун учурдагы статусун көзөмөлдөй аласыз.<br /><br /> Кардарлардан төлөм кабыл алууну баштоо үчүн соода чекитин түзүп, товарларды кошуп, RC PAY аркылуу жеткиликтүү болгон соода чекиттерде буйрутмаларды кабыл алууну иштетүү керек.",
    },
  },

  services: {
    title: "Сервистер",
    eMenu: {
      title: "Онлайн каталог",
      p: "<b>«Онлайн каталог»</b> баракчасында сиз өз товарлоруңузду же кызматтарыңызды кошуп, кардарлардын сиздин мекемеңиздин же дүкөнүңүздүн ассортиментине rcpay.ru сайты аркылуу же RC PAY тиркемесинде таанышышын камсыздай аласыз. Ошондой эле баракчанын ылдый жагында QR-код түзүп, жүктөп алсаңыз болот — бул сиздин соода чекитиңиздин менюсуна бир нече чыкылдатуу менен жетүүгө мүмкүндүк берет.",
    },
  },

  contacts: {
    title: "Байланыш",
    p: "Бардык суроолор боюнча <b>8 (800) 500-57-62</b> телефон номерине же hello&#64;rc.city электрондук почтасына кайрылыңыз. Же болбосо оң жак ылдыйкы бурчтагы байланыш формасын колдонуп сурооңузду жөнөтүңүз, биз сиз менен ыңгайлуу жол менен байланышабыз.",
  },
};
